import { FC } from "react";
import { IranianBank } from "iranian-bank-logo-react";

export const BANK_CLASS_NAMES: Record<string, string> = {
  پاسارگاد: "ir-pasargad",
  شهر: "ir-shahr",
  "توسعه تعاون": "ir-tose-taawon",
  کارآفرین: "ir-karafarin",
  دی: "ir-day",
  گردشگری: "ir-gardeshgari",
  تجارت: "ir-tejarat",
  سپه: "ir-sepah",
  رفاه: "ir-refah",
  صادرات: "ir-saderat",
  کشاورزی: "ir-keshavarzi",
  ملّی: "ir-melli",
  "مهر ایرانیان": "ir-mehr",
  ملت: "ir-mellat",
  سامان: "ir-saman",
  بلو: "ir-blu",
  پارسیان: "ir-parsian",
  اقتصادنوین: "ir-eghtesad-novin",
  "پست بانک": "ir-post-bank",
  "صنعت و معدن": "ir-sanat-madan",
  مسکن: "ir-maskan",
  سینا: "ir-sina",
  رسالت: "ir-resalat",
  "ایران زمین": "ir-iranzamin",
  انصار: "unknown",
  "توسعه صادرات": "unknown",
  "موسسه اعتباری توسعه": "unknown",
  آینده: "unknown",
  حکمت: "unknown",
  "مهر اقتصاد": "unknown",
  قوامین: "unknown",
  سرمایه: "unknown",
  عسکریه: "unknown",
  خاورمیانه: "unknown",
};

const SIZE_MAP = { sm: 32, md: 64, lg: 128 };

const BankLogo: FC<{ name: string; size: "sm" | "md" | "lg"; className?: string }> = ({
  name,
  size = "md",
  className,
}) => {
  const bankId = BANK_CLASS_NAMES[name] ?? "unknown";
  return <IranianBank name={bankId} size={SIZE_MAP[size]} className={className} />;
};

export default BankLogo;
